import React from 'react'
import PropTypes from 'prop-types'
import { ExportOutlined } from '@ant-design/icons'

import style from './index.module.scss'

const InfoCard = ({ value, label, isButton = false, onClick = () => {} }) => {
	const displayValue = value ?? 'Não informado'

	return (
		<div
			className={`${style.infoCard} ${isButton ? style.infoCardButton : ''}`}
			onClick={isButton ? onClick : undefined}>
			<div className={style.infoCardValue}>
				<p>{displayValue}</p>
				{isButton && <ExportOutlined style={{ fontSize: 18 }} />}
			</div>
			<span>{label}</span>
		</div>
	)
}

InfoCard.propTypes = {
	value: PropTypes.string,
	label: PropTypes.string,
	isButton: PropTypes.bool,
	onClick: PropTypes.func,
}

export default function InfoGrid({ infoItems }) {
	return (
		<div className={style.infoGrid}>
			{infoItems.map((item) => (
				<InfoCard key={item.label} {...item} />
			))}
		</div>
	)
}

InfoGrid.propTypes = {
	infoItems: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string,
			label: PropTypes.string,
		})
	).isRequired,
}
